import { SEND_MESSAGE, SET_SENT_MESSAGE_STATUS } from './constants'

import { failure, success, status } from '@utils/redux'

const initialState = {
  message: {
    data: {},
    status: status.PRISTINE,
    error: {}
  },
  alreadySentMessage: false
}

const contact = (state = initialState, action) => {
  switch (action.type) {
    case SEND_MESSAGE:
      return {
        ...state,
        message: {
          ...state.message,
          status: status.FETCHING
        }
      }
    case failure(SEND_MESSAGE):
      return {
        ...state,
        message: {
          ...state.message,
          status: status.ERROR,
          error: action.error
        }
      }
    case success(SEND_MESSAGE):
      return {
        ...state,
        message: {
          ...state.message,
          status: status.LOADED,
          error: false,
          data: action.payload.data
        }
      }
    case SET_SENT_MESSAGE_STATUS:
      return {
        ...state,
        alreadySentMessage: action.payload
      }
    default:
      return state
  }
}

export default contact
